<template>
  <form class="d-grid gap-2" :class="{'is-invalid': errorMessage }">
    <validation-errors v-if="errorMessage" :errors="[errorMessage]" />
    <textarea v-model="value" :placeholder="placeholder"
              class="form-control"
              :class="sizeClass"
              :name="name"
              required />
    <div class="button-row">
      <submit-button :form-valid="!!value" :submit-in-progress="submitInProgress" :label="buttonText" class="btn-sm" @click="create" />
    </div>
  </form>
</template>

<script>
import { inject } from 'vue'
import SubmitButton from '../buttons/submit-button'
import ValidationErrors from './validation-errors'

export default {
  components: {
    SubmitButton, ValidationErrors
  },

  props: {
    buttonText: {
      type: String,
      required: false,
      default: function() { return inject('i18n').t('administrative.save') }
    },
    placeholder: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    },
    createAction: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      submitInProgress: false,
      errorMessage: '',
      value: ''
    }
  },
  computed: {
    sizeClass() {
      switch (this.size) {
      case 'xs':
      case 'sm':
      case 'md':
      case 'lg':
        return `textarea-${this.size}`
      default:
        return ''
      }
    }
  },

  methods: {
    clear() {
      this.submitInProgress = false
      this.value = ''
      this.errorMessage = ''
    },
    create: async function() {
      this.submitInProgress = true
      try {
        await this.createAction(this.value)
        this.clear()
      }
      catch (e) {
        this.submitInProgress = false
        this.errorMessage = e.message
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
  }

  .button-row {
    display: none;
  }

  .textarea-xs {
    max-height: 20px;
  }

  .textarea-sm {
    max-height: 34px;
  }

  .textarea-md {
    max-height: 50px;
  }

  .textarea-lg {
    max-height: 70px;
  }

  textarea {
    overflow-y: hidden;

    // Depending on `required` attribute
    // of `textarea` to detect
    // when the `textarea` is not empty
    // https://stackoverflow.com/a/7072737
    &:focus, &:not(:invalid) {
      min-height: 100px;
      overflow-y: auto;

      & + .button-row {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 5px;
      }
    }
  }
</style>
